import { atom } from 'jotai';
import { PlanetMosaicItem, PlanetMosaicType } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export const planetItemsLEFTAtom = atom<PlanetMosaicItem[]>([]);

export const planetItemsRIGHTAtom = atom<PlanetMosaicItem[]>([]);

// Shared filter state atoms (used by both SatelliteImagePanel and PlanetFinder)
export const planetFilterTypeAtom = atom<PlanetMosaicType>(PlanetMosaicType.MONTHLY);
export const planetFilterYearAtom = atom<number>(new Date().getFullYear());
export const planetFilterMonthAtom = atom<number | null>(null);
export const planetFilterQuarterAtom = atom<number>(1);